<template>
    <div class="ReportGroupFilterBar">
        <div class="container-fluid">
            <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
                <div class="col-md-3 col-lg-3">
                </div>
                <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
                    Group(s)
                </div>    
                <div class="col-md-3 col-lg-3">
                    <div class="form-group">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                          <select class="form-control Padding-right-0px" v-model="selectedGroupObj">
                            <option value=-1 disabled>Select</option>
                            <option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                          </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                  <!-- ToDo: Track this -->
                    <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event,false)">View</button>
                </div>
                <div class="col-md-1 col-lg-1">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event,true)" v-if="getShowExportState">Export</button>
                </div>
                <div class="col-md-3 col-lg-3">
                </div>
            </div>
            <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
            <!-- Show Spinner -->
            <div class="animationload" v-show="showSpinner">
              <div class="osahanloading"></div>
            </div>  
            <loader></loader>    
        </div>
    </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import AlertBox from '@/components/AlertOverlay'
export default {
  props: ['showExport'],
  created: function () {
    this.getGroups()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedGroupObj: -1
    }
  },
  methods: {
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.selectedGroupObj !== -1) {
        // AK: Emit selected Group Obj
        this.$emit('selectedGroupObj', this.selectedGroupObj)
        if (isExportBtnClicked) {
          this.$emit('isExportBtnClicked', true)
          this.$emit('isViewBtnClicked', false)
        } else {
          this.$emit('isExportBtnClicked', false)
          this.$emit('isViewBtnClicked', true)
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select a group.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        } else {
          _this.groupList = storeObj.state.groupList
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    },
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    }
  },
  watch: {},
  name: 'ReportGroupFilterBar'
}
</script>

<style scoped>
.ReportFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.font-size-18px{
    font-size: 18px !important;
}
.text-align-right{
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/ReportGroupFilterBar.vue